import {
    OPEN_ORDER_DETAILS,
    CLOSE_ORDER_DETAILS,
    SEND_TO_SUPPLIER,
    UPDATE_SUGGESTED_ADDRESSES,
    CHANGE_SHOP_STATE,
} from "./orderDetails.actionsTypes";
import {
    BASE_URL,
} from "../../config";
import axios from "axios";
import delivery from "../../components/delivery/delivery";
import Notifier from "../../components/message/Notifier";
import { GET_GIFT_CARD } from "../GiftCard/giftCard.actionsTypes";
import { ERRORS } from "../../config/constants";

export const openOrderDetailsModal = (order, restaurants, isNotEditable) => {
    return {
        type: OPEN_ORDER_DETAILS,
        order,
        restaurants,
        isNotEditable,
    };
};

export const getGiftCards = () => {
    return (dispatch) => {
        axios.get(`${BASE_URL}giftCard/`)
            .then((response) => {
                if (response.data) {
                    return dispatch({
                        type: GET_GIFT_CARD,
                        giftCards: response.data,
                    });
                }
            });
    };
};

export const getRestaurantsByIDs = (ids) => {
    return () => {
        const idsString = Array.isArray(ids) ? ids.join(",") : ids;
        return axios.get(`${BASE_URL}v2/restaurant/${idsString}`)
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                console.error("Error fetching restaurants:", err);
                return [];
            });
    };
};

export const openOrderDetails = (order, isNotEditable) => {
    return (dispatch) => {
        const { shops } = order,
            ids = [];

        for (let i = 0, len = shops.length; i < len; i++) {
            if (shops[i].restaurantInfo) {
                const id = shops[i].restaurantInfo._id;
                if (ids.indexOf(id) === -1) {
                    ids.push(id);
                }
            }
        }

        if (ids.length) {
            axios.get(`${BASE_URL}v2/order/details/${order._id}`)
                .then((res, err) => {
                    if (!err) {
                        // dispatch(getRestaurantsByIDs(ids, order, isNotEditable));
                        dispatch(openOrderDetailsModal(res.data, [res.data.shops[0].restaurantInfo], isNotEditable));
                    }
                });
        } else {
            dispatch(openOrderDetailsModal(order, [], isNotEditable));
        }
    };
};

export const openBookOrderDetails = (order, isNotEditable) => {
    return (dispatch) => {
        if (!order || !order.bookId) {
            return dispatch(openOrderDetails(order, isNotEditable));
        }

        axios
            .get(`${BASE_URL}v2/order/book/details/${order._id}`)
            .then((res, err) => {
                if (!err && res && res.data) {
                    const data = res.data;
                    const restaurants =
                        data.shops && data.shops.length && data.shops[0].restaurantInfo
                            ? [data.shops[0].restaurantInfo]
                            : [];

                    dispatch(openOrderDetailsModal(data, restaurants, isNotEditable));
                }
            });
    };
};

export const closeOrderDetails = () => {
    return {
        type: CLOSE_ORDER_DETAILS,
    };
};

export const orderHistoryByApi = (order, callback) => {
    return (dispatch) => {
        axios.get(`${BASE_URL}order/history/${order._id}`, order)
            .then(callback.bind(this, dispatch));
    };
};

export const confirmCall = (orderId, supplierId, state) => {
    return (_) => {
        axios.put(`${BASE_URL}order/setPartnerSetTime/${orderId}/${supplierId}`)
            .then(() => {
                const session = delivery.getSession();
                session.emit("delivery:supplierStateUpdate", {
                    orderId,
                    supplierId,
                    state,
                });
            });
    };
};

export const updateProduct = (product, orderId) => {
    return () => {
        axios.put(`${BASE_URL}order/discuss/${orderId}/${product._id}`, product);
    };
};

export const hideSendToPartnerButton = (shopId, order) => {
    return {
        type: SEND_TO_SUPPLIER,
        shopId,
        order,
    };
};

export const hideChangeShopStateButton = (shopId, order) => {
    return {
        type: CHANGE_SHOP_STATE,
        shopId,
        order,
    };
};

export const sendToPartner = (orderId, shop) => {
    return (dispatch) => {
        return axios
            .put(`${BASE_URL}order/sendToPartner/${orderId}/${shop._id || shop.shopId}/${shop.branch || null}`)
            .then((res) => {
                dispatch(hideSendToPartnerButton(shop._id, res.data));
                return res;
            })
            .catch((err) => {
                throw err;
            });
    };
};

export const sendToHaysell = (shop, orderId) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}order/sendToHaysell/${orderId}/${shop._id}`)
            .then((res, err) => {
                if (!err) {
                    dispatch(hideSendToPartnerButton(shop._id, res.data));
                }
            });
    };
};

export const sendToOptime = (orderId) => {
    return (_) => {
        axios.post(`${BASE_URL}order/${orderId}/optime`)
            .then((res, err) => {
                if (!err) {
                    return;
                }
            });
    };
};

export const updateShopState = (shop, orderId) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}order/changeShopState/${orderId}/${shop._id}`)
            .then((res, err) => {
                if (!err) {
                    dispatch(hideChangeShopStateButton(shop._id, res.data));
                }
            });
    };
};

export const selectShopBranch = (shop, orderId, branch, cb = () => {
}) => {
    return () => {
        axios.put(`${BASE_URL}order/selectBranch/${orderId}/${shop._id}`, { branch })
            .then((res, err) => {
                if (!err) {
                    cb();
                }
            }).catch(err => console.error("selectShopBranch: ", err));
    };
};

export const updateSuggestedAddresses = (addresses) => {
    return {
        type: UPDATE_SUGGESTED_ADDRESSES,
        addresses,
    };
};

export const searchAddress = (key, cb = () => {
}) => {
    return (dispatch) => {
        axios.get(`${BASE_URL}order/searchAddress/${key}`)
            .then((res, err) => {
                if (!err && res && res.data && res.data.length && !res.data[0].isOutOfDelivery) {
                    dispatch(updateSuggestedAddresses(res.data));
                    cb(res.data);
                }
            });
    };
};

export const reverseGeocode = (lat, lng, cb = () => {}) => {
    return () => {
        axios.get(`https://dispatch.buy.am/geo/reverse-search/${lat}/${lng}`)
            .then((res, err) => {
                if (!err && res && res.data) {
                    cb(res.data);
                } else {
                    cb(null);
                }
            })
            .catch(() => {
                cb(null);
            });
    };
};

export const divideOrder = (data, cb) => {
    return () => {
        axios.post(`${BASE_URL}order/divideOrder`, { order: data })
            .then((res, err) => {
                if (!err && res) {
                    Notifier.success("_order_successfully_updated_", "_order_updated_");
                }
                cb(err);
            });
    };
};

export const getShopsForMergeOrder = (params, cb) => {
    return () => {
        axios.get(`${BASE_URL}order/mergeOrder/${params.parentOrderId || 0}/${params.orderId || 0}/${params.customerId}`)
            .then((res, err) => {
                if (!err && res && res.data && res.data.length > 1) {
                    cb(res.data);
                }
            });
    };
};

export const removeShopsFromOrder = (params, cb) => {
    return () => {
        axios.put(`${BASE_URL}order/removeShops/${params.orderId}`, { shopIds: params.shops })
            .then((res, err) => {
                if (!err && res && res.data) {
                    cb(res.data);
                } else {
                    cb();
                }
            });
    };
};
export const divideOrderAuto = (params, cb) => {
    return () => {
        axios.post(`${BASE_URL}order/divideOrder/${params.orderId}`)
            .then((res, err) => {
                if (!err && res) {
                    Notifier.success("_order_successfully_updated_", "_order_updated_");
                }
                cb(err);
            });
    };
};

export const deliverPickUpOrder = (orderId, cb) => {
    return async (dispatch) => {
        try {
            const res = await axios.post(`${BASE_URL}v2/order/pickup/${orderId}/delivered`);
            Notifier.success("_order_successfully_updated_", "_order_updated_");
            dispatch({ type: "ORDER_PICKUP_SUCCESS", payload: orderId });
        } catch (err) {
            Notifier.error("_order_update_failed_");
            cb(err);
        }
    };
};

export const deliverOrder = (orderId, cb) => {
    return async (dispatch) => {
        try {
            const res = await axios.post(`${BASE_URL}v2/order/deliver/${orderId}`);
            Notifier.success("_order_successfully_updated_", "_order_updated_");
            dispatch({ type: "ORDER_DELIVER_SUCCESS", payload: orderId });
        } catch (err) {
            Notifier.error("_order_update_failed_");
            cb(err);
        }
    };
};
